// ── zLayers ───────────────────────────────────────────────────────────────────
// One stacking-order convention so overlays never collide by accident. The app
// had ~30 ad-hoc zIndex values (1000–99999); these are the canonical tiers.
// Higher = closer to the viewer. Use the named tier in new code.
//
// The celebration CHAIN (wrap → card → finalcut) has a deliberate internal order
// that already works, so it is intentionally NOT re-stacked here — these tiers
// govern new code and standalone overlays.
//
// NOTE: there is a PARALLEL scale of CSS custom properties in index.css
// (--z-nav / --z-dropdown / --z-toast / --z-modal / --z-modal-nested /
// --z-celebration). The two scales are independent but MUST agree at the one tier
// they share in practice — the finale/celebration top layer (9900 here =
// --z-celebration there). If you renumber either, keep that tier aligned.
export const Z = {
  nav:         1000,   // bottom nav, sticky headers
  dropdown:    2000,   // menus, popovers
  toast:       9000,   // transient toasts (rating saved, activity, celebration toast)
  sheet:       9400,   // bottom sheets / standard modals
  modal:       9600,   // focused modals (card detail, image viewer)
  cinematic:   9800,   // full-screen cinematics (recap, race start, wrap)
  finale:      9900,   // top cinematics (final cut, milestone)
  system:    100000,   // critical system overlays (install prompt, fatal error)
}
